module.exports = __webpack_public_path__ + "img/push-pin-slash.7f2f3db0.svg";